import EditLinkContainer from "../containers/EditLinkContainer";

const EditLinkPage = () => {
  return (
    <EditLinkContainer />
  );
};

export default EditLinkPage;
